import React from 'react';
import styles from './index.module.scss';

export default function TitleTag({ children, style }: any) {
  return (
    <div className={styles.titletag} style={style}>
      {children}
    </div>
  );
}
